module.exports = __webpack_public_path__ + "img/rule2.aa7139aa.png";